import React from 'react'
import i18n from 'live/services/i18n'

type Props = {
    purgeRule: PurgeRule
    readonly: boolean
    setEditingRule: (purgeRule: PurgeRule) => void
    removePurgeRule: (PurgeRule: PurgeRule) => void
}

const PurgeRule = ({ purgeRule, readonly, setEditingRule, removePurgeRule }: Props): JSX.Element => {
    return (
        <>
            <td>
                <i className={`fa fa-${purgeRule.recurrent ? 'repeat' : 'circle'}`} />
                <span>{purgeRule.recurrent ? i18n('Recurrent') : i18n('One-Time')}</span>
            </td>
            <td style={{ color: 'var(--red-500)' }}>
                <i className="fa fa-eraser" />
                <span>{i18n('Delete')}</span>
            </td>
            <td>
                <span style={{ wordBreak: 'break-all' }}>{purgeRule.eventType}</span>
            </td>
            <td>
                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <span>{purgeRule.timeRange}</span>
                    {!readonly && (
                        <div>
                            <a
                                onClick={() => {
                                    setEditingRule(purgeRule)
                                }}
                            >
                                <i className="fa fa-pencil" style={{ color: 'var(--blue-500)' }} />
                            </a>
                            <a onClick={() => removePurgeRule(purgeRule)}>
                                <i
                                    className="fa fa-times-circle-o"
                                    style={{
                                        marginLeft: '16px',
                                        color: 'var(--red-500)'
                                    }}
                                />
                            </a>
                        </div>
                    )}
                </div>
            </td>
        </>
    )
}

export default PurgeRule
